import { SettingsValueProps, ThemeColorPresetsValue } from './types';
import { getRuntimeEnv } from '../../utils/runtimeEnv';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

/**
 * 根据环境变量获取默认主题色
 * - test: 绿色 (default)
 * - prod: 蓝色 (blue)
 * - dev: 紫色 (purple) - 与绿色和蓝色不冲突
 */
function getDefaultThemeColorPresets(): ThemeColorPresetsValue {
  const env = getRuntimeEnv('REACT_APP_ENV', 'dev')?.toLowerCase();

  switch (env) {
    case 'test':
      return 'default'; // 绿色
    case 'prod':
    case 'production':
      return 'blue'; // 蓝色
    case 'dev':
    case 'development':
    default:
      return 'purple'; // 紫色
  }
}

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'vertical',
  themeColorPresets: getDefaultThemeColorPresets(),
  themeStretch: false,
};
